import React, { useContext, lazy, Suspense } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import "./index.css";
import "./chart.css";
import "./step.css";
import Nav from "./layouts/nav";
import Nav2 from "./layouts/nav/index2";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import WalletBar from './layouts/WalletBar';
import { ThemeContext } from "../context/ThemeContext";
import ManageDepositors from "./pages/Depositors/manage-depositors";
import AddUpdateDepositor from "./pages/Depositors/add-update-depositor";
import ViewDepositor from "./pages/Depositors/view-depositor";
import ManageDepositorKyc from "./pages/Depositors/manage-depositor-kyc";
const Home = lazy(() => import("./components/Dashboard/Home"));
const Setting = lazy(() => import("./layouts/Setting"));
const ManageKyc = lazy(() => import("./pages/KycMaster/ManageKyc"));
const AddEditKyc = lazy(() => import("./pages/KycMaster/AddEditKyc"));
const ManageCompanies = lazy(() => import("./pages/Companies/ManageCompanies"));
const AddEditCompany = lazy(() => import("./pages/Companies/AddEditCompany"));
const ManageCompanyBalance = lazy(() => import("./pages/CompanyBalance/ManageCompanyBalance"));
const CompanyBalanceLogs = lazy(() => import("./pages/CompanyBalance/CompanyBalanceLogs"));
const ManageCompanyKyc = lazy(() => import("./pages/CompanyKyc/ManageCompanyKyc"));
const AddEditCompanyKyc = lazy(() => import("./pages/CompanyKyc/AddEditCompanyKyc"));
const ManageBranches = lazy(() => import("./pages/Branches/ManageBranches"));
const AddEditBranch = lazy(() => import("./pages/Branches/AddEditBranch"));
const ManageUsers = lazy(() => import("./pages/Users/ManageUsers"));
const AddEditUser = lazy(() => import("./pages/Users/AddEditUser"));
const UserRoleAssignment = lazy(() => import("./pages/Users/UserRoleAssignment"));

 const Markup = () => {
   const ViewProfile = lazy(() => import('./pages/Profile/ViewProfile'));
   const EditProfile = lazy(() => import('./pages/Profile/EditProfile'));
   const MenuListPage = lazy(() => import('./pages/MenuConfig/MenuList'));
   const MenuFormPage = lazy(() => import('./pages/MenuConfig/MenuForm'));
   const MenuRoleAssignmentPage = lazy(() => import('./pages/MenuConfig/MenuRoleAssignment'));
  const ListDeposits = lazy(() => import("./pages/Deposits/list-deposits"));
  const AddDeposit = lazy(() => import("./pages/Deposits/add-deposit"));
  const ViewDeposit = lazy(() => import("./pages/Deposits/view-deposit"));
  const EditDeposit = lazy(() => import("./pages/Deposits/edit-deposit"));
  const ListDepositInterest = lazy(() => import("./pages/DepositInterest/list-deposit-interest"));
  const AddInterestPayment = lazy(() => import("./pages/DepositInterest/add-interest-payment"));
  const ViewDepositInterest = lazy(() => import("./pages/DepositInterest/view-deposit-interest"));
  const DepositInterestReceipt = lazy(() => import("./pages/DepositInterest/receipt-deposit-interest"));
  const allRoutes = [
  { url: "/profile", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ViewProfile/></Suspense>) },
  { url: "/profile/edit", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><EditProfile/></Suspense>) },
    { url: "/depositors", component: <ManageDepositors/> },
    { url: "/depositors/create", component: <AddUpdateDepositor/> },
    { url: "/depositors/edit/:id", component: <AddUpdateDepositor/> },
    { url: "/depositors/view/:id", component: <ViewDepositor/> },
    { url: "/depositors/kyc/:id", component: <ManageDepositorKyc/> },
    { url: "/deposits", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ListDeposits/></Suspense>) },
    { url: "/deposits/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddDeposit/></Suspense>) },
    { url: "/deposits/view/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ViewDeposit/></Suspense>) },
    { url: "/deposits/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><EditDeposit/></Suspense>) },
    { url: "/deposit-interest", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ListDepositInterest/></Suspense>) },
    { url: "/deposit-interest/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddInterestPayment/></Suspense>) },
    { url: "/deposit-interest/view/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ViewDepositInterest/></Suspense>) },
    { url: "/deposit-interest/receipt/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><DepositInterestReceipt/></Suspense>) },
    { url: "/menu-config", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><MenuListPage/></Suspense>) },
    { url: "/menu-config/new", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><MenuFormPage/></Suspense>) },
    { url: "/menu-config/:id/edit", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><MenuFormPage/></Suspense>) },
    { url: "/menu-config/:id/roles", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><MenuRoleAssignmentPage/></Suspense>) },
    { url: "/kyc-master", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageKyc/></Suspense>) },
    { url: "/kyc-master/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditKyc/></Suspense>) },
    { url: "/kyc-master/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditKyc/></Suspense>) },
    { url: "/companies", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageCompanies/></Suspense>) },
    { url: "/companies/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditCompany/></Suspense>) },
    { url: "/companies/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditCompany/></Suspense>) },
    { url: "/company-balance", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageCompanyBalance/></Suspense>) },
    { url: "/company-balance-logs/:companyId", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><CompanyBalanceLogs/></Suspense>) },
    { url: "/company-kyc", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageCompanyKyc/></Suspense>) },
    { url: "/company-kyc/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditCompanyKyc/></Suspense>) },
    { url: "/company-kyc/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditCompanyKyc/></Suspense>) },
    { url: "/branches", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageBranches/></Suspense>) },
    { url: "/branches/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditBranch/></Suspense>) },
    { url: "/branches/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditBranch/></Suspense>) },
    { url: "/branches/view/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditBranch/></Suspense>) },
    { url: "/users", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><ManageUsers/></Suspense>) },
    { url: "/users/add", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditUser/></Suspense>) },
    { url: "/users/edit/:id", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><AddEditUser/></Suspense>) },
    { url: "/users/:id/roles", component: (<Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}><UserRoleAssignment/></Suspense>) },
  ];
  return (
    <>
      <Suspense fallback={<div className="text-center p-4"><div className="spinner-border text-primary" /></div>}>
        <Routes>
          <Route element={<Layout7 />}>
            <Route path='/' exact element={<Home/>} />
            <Route path='/dashboard' exact element={<Home/>} />
            { allRoutes.map((data, i) => (
              <Route key={i} exact path={`/${data.url}`} element={data.component} />
            ))}
          </Route>
        </Routes>
        <Setting/>
        <ScrollToTop />
      </Suspense>
    </>
  );
};

function Layout1(){
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`wallet-open active show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>
      <Nav2 />
      <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
        <div className="container-fluid">
          <Outlet />
          <Footer />
        </div>
      </div>
      <WalletBar />
      <div className="wallet-bar-close"></div>
    </div>
  );
}
function Layout2(){
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer changeFooter="out-footer"/>
    </div>
  );
}
function Layout7(){
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
export default Markup;